import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { HEADER_DATA_SOURCE } from '../externals';
import { GET_USER_DATA, GET_USER_DATA_RETRO_FIT, SIGN_OUT_USER } from './headerOperations';
import { logGQLErrors } from './logGQLErrors';

function useHeaderData(envUrl, user, cartCount, onClickSignOut, skipDataQuery, navType, userCourses, isRetro) {
  var fetchDynamicData = {
    user: typeof user === 'undefined',
    cartCount: typeof cartCount === 'undefined',
    userCourses: typeof userCourses === 'undefined'
  }; // skip the data query if enforced via skipDataQuery or all data is provided already

  var skipGQLQuery = skipDataQuery !== null && skipDataQuery !== void 0 ? skipDataQuery : typeof isRetro !== 'undefined' && isRetro ? !fetchDynamicData.user && !fetchDynamicData.cartCount && !fetchDynamicData.userCourses : !fetchDynamicData.user && !fetchDynamicData.cartCount;

  var _useQuery = useQuery(isRetro ? GET_USER_DATA_RETRO_FIT : GET_USER_DATA, {
    context: _defineProperty({}, HEADER_DATA_SOURCE, true),
    // This variable is required to log traffic into NewRelic coming from different clients
    variables: {
      navType: navType
    },
    ssr: false,
    skip: skipGQLQuery,
    errorPolicy: 'all',
    fetchPolicy: 'no-cache'
  }),
      userGQLQueryLoading = _useQuery.loading,
      userData = _useQuery.data,
      userDataError = _useQuery.error;

  var _useMutation = useMutation(SIGN_OUT_USER, {
    context: _defineProperty({}, HEADER_DATA_SOURCE, true),
    // This variable is required to log traffic into NewRelic coming from different clients
    variables: {
      navType: navType
    },
    fetchPolicy: 'no-cache'
  }),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      signOutMutation = _useMutation2[0];

  var signOutUser = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var _signOutData$data, _signOutData$data$sig, signOutData;

      return _regeneratorRuntime.wrap(function _callee$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              event.preventDefault();
              _context3.next = 4;
              return signOutMutation();

            case 4:
              signOutData = _context3.sent;

              // ignoring this as optional chaining has open issues with satisfying branch coverage: https://github.com/istanbuljs/istanbuljs/issues/516

              /* istanbul ignore next */
              if (signOutData !== null && signOutData !== void 0 && (_signOutData$data = signOutData.data) !== null && _signOutData$data !== void 0 && (_signOutData$data$sig = _signOutData$data.signout) !== null && _signOutData$data$sig !== void 0 && _signOutData$data$sig.success) {
                // now that the user is signed out, execute the provided callback else simply redirect to sign-out page
                onClickSignOut ? onClickSignOut(event) : window.location.href = "".concat(envUrl, "signout?onlyView=1");
              } else console.error('Header - Sign-out not successful');

              _context3.next = 11;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);
              // log mutation errors for better debugging
              logGQLErrors('Header - Sign out', _context3.t0);

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function signOutUser(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(function () {
    // log query errors for better debugging, in case there are any
    logGQLErrors('Header - User Data Fetching', userDataError);
  }, [userDataError]); // userDataLoading essentially indicates if the user data is currently being loaded via the GQL query

  var userDataLoading = !skipGQLQuery && userGQLQueryLoading;
  return {
    userData: userData,
    signOutUser: signOutUser,
    userDataLoading: userDataLoading
  };
}

export default useHeaderData;